export default __webpack_public_path__ + "static/media/zine-cover7.7598a450.png";